import { HTTP_STATUSES } from "@miplatform/constants";
import { TASK_SERVICE } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const CALENDAR_CONFIG = `${TASK_SERVICE}/config`;

export const config = {
  getConfig: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: CALENDAR_CONFIG,
      method: "get",
      signal,
      params,
      filters,
      sort,
    });

    const response = await apiRequest(options);
    if (response.status === HTTP_STATUSES.OK) {
      return response.data;
    }

    return [];
  },
};
